import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { CalibrationId, CalibrationGear } from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import Bold from 'components/Bold';
import { makeSelectGear } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    gear: CalibrationGear;
}

type Props = OwnProps & ConnectedProps;

export class GearTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { gear } = this.props;

        return (
            <TableCell>
                <Bold>{gear}</Bold>
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    gear: makeSelectGear()
});

export default connect(mapStateToProps)(GearTableCellComponent);
